export const config = {
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token',
  API_HOST: process.env.REACT_APP_API_HOST,
  // the agent portal (on prod the API lives on the portal's domain)
  PORTAL_URL: process.env.REACT_APP_PORTAL_URL || process.env.REACT_APP_API_HOST,
  ROLES: {
    ADMIN: 'ADMIN',
  },
  LANGUAGES: {
    AM: {
      email: 'էլ. փոստ',
      password: 'Գաղտնաբառ',
      studentPage: 'Ուսանողի ընտրության էջ',
      repassword: 'Գաղտնաբառի կրկնում',
      log_out: 'Դուրս գալ',
      loginPage: 'Մուտք',
      regPage: 'Գրանցում',
      log_in: 'Մուտք',
      sign_up: 'Գրանցվել',
      first_name: 'Անուն',
      last_name: 'Ազգանուն',
      patronymic: 'հայրանուն',
      daysLeftForChoice: `Դուք ունեք $$dayCount$$ օր ժամանկ՝ ընտրելու 2-րդ օտար լեզու`,
      createAccount: 'Մուտքագրեք ձեր անձնական տվյալները',
      chooseLang: `2-րդ օտար լեզվի ընտրություն`,
      choose: 'Ընտրել',
      confirm_choice: `Դուք հաստատում եք ձեր ընտրությունը?`,
      serial: 'Անձնագրի համար',
      login: 'Մուտքագրեք ձեր անձնական տվյալները`\n մուտքանունը և գաղտնաբառը',
      noSeatsLeft: 'Տվյալ լեզվի խմբերի քանակը լրացել է, ընտրեք այլ լեզու',
      registerFailed: 'Անձնագրի տվյալները սխալ են մուտքագրված: Կրկին փորձեք կամ դիմեք Ձեր ֆակուլտետի դեկանատ:',
      fillAllInput:
        'Գրանցվելու համար անհրաժեշտ է բոլոր դաշտերը լրացված լինեն։ Կրկին փորձեք կամ դիմեք Ձեր ֆակուլտետի դեկանատ:',
      passEqRepass: 'Գաղտաբառը երկու դաշտերում էլ պետք է նույնը լինի։ Կրկին փորձեք կամ դիմեք Ձեր ֆակուլտետի դեկանատ:',
      passLength: 'Գաղտաբառը պետք է լինի նվազագույնը 6(վեց) նիշ։ Կրկին փորձեք կամ դիմեք Ձեր ֆակուլտետի դեկանատ։',
    },
    EN: {
      fillAllInput: "All fields must be filled for register. Please try again or ask your Faculty Dean's office.",
      passEqRepass: "The password must be the same in both fields. Please try again or ask your Faculty Dean's office.",
      passLength: "The password must be at least six characters. Please try again or ask your Faculty Dean's office.",
      email: 'email',
      password: 'password',
      repassword: 'Repeat password',
      first_name: 'First Name',
      studentPage: 'Student page',
      loginPage: 'Login',
      regPage: 'Register',
      last_name: 'Last Name',
      patronymic: 'Patronymic',
      confirm_choice: `Do you want to confirm your choice?`,
      log_out: 'Log out',
      log_in: 'Log in',
      sign_up: 'Sign up',
      serial: 'Passport number',
      daysLeftForChoice: `You have $$dayCount$$ days to choose your second foreign language`,
      chooseLang: `Choose your second foreign language.`,
      choose: 'Choose',
      createAccount: 'Please enter your personal information',
      login: 'Please enter your username and password.',
      noSeatsLeft: 'There are no more available seats in this class, please choose a different language.',
    },
  },
};
